import {localAxiosRequest} from "@/utils/axios";
const SEARCH_BASE_URL = '/search';

/**
 * 获取配置文件参数
 */
const getSearchConfs = function (){
    return localAxiosRequest({
        method: 'GET',
        url: `${SEARCH_BASE_URL}/search_confs`,
    });
};

export { getSearchConfs };
